import { Component, OnInit } from '@angular/core';
import { IHeaderTitle } from 'app/shared/models/header-title';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Result } from 'app/core/models/result';
import { Router, ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { ResponseTypeModel } from 'app/question/models/response-type.model';
import { QuestionService } from 'app/question/services/question.service';
import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { ChangeEvent } from '@ckeditor/ckeditor5-angular';
import { QuestionAnswerModel } from 'app/question/models/question-answer.model';

@Component({
    selector: 'app-add-question',
    templateUrl: './add-question.component.html',
    styleUrls: ['./add-question.component.css']
})
export class AddQuestionComponent implements OnInit {
    public title = ClassicEditor;
    headerTitle: IHeaderTitle;
    errors: string[];
    responseTypes: ResponseTypeModel[];
    submitAttempt: boolean = false;
    addQuestionFormGroup: FormGroup;
    titleData: string = '';
    //options: any[] = [];
    questionAnswers: QuestionAnswerModel[] = [];
    questionBankId: string;

    constructor(
        private questionService: QuestionService,
        private fb: FormBuilder,
        private location: Location,
        private router: Router,
        private _activatedRoute: ActivatedRoute
    ) { }

    ngOnInit() {
        this.headerTitle = {
            title: 'Add Question', breadcrumbs: [
                { title: 'Questions', url: ['/question'] }
            ]
        }

        this.questionBankId = this._activatedRoute.snapshot.params['id'];

        this.getResponseTypes();
        this.initializeForm();
    }

    ngAfterViewInit(): void {
        //alert(this.questionBankId);

    }

    getResponseTypes(): void {
        this.questionService.getResponseTypes().subscribe(result => {
            this.responseTypes = result;
        });
    }

    initializeForm(): void {
        this.addQuestionFormGroup = this.fb.group(
            {
                title: ['', Validators.required],
                //description: ['', Validators.required],
                responseTypeId: ['', Validators.required],
                options: [''],
                weighting: [1],
                isActive: [true, Validators.required]
            }
        );
    }

    changeTitle({ editor }: ChangeEvent) {
        const editorData = editor.data.get();
        this.addQuestionFormGroup.get('title').setValue(editorData);
    }

    addQuestion(): void {
        this.submitAttempt = true;
        if (this.addQuestionFormGroup.valid) {
            const formValue = this.addQuestionFormGroup.value;
            formValue.questionAnswers = this.questionAnswers;

            this.questionService.create(formValue).subscribe(
                questionId => {
                    if (this.questionBankId) {
                        this.router.navigate(['./question/' + questionId], { queryParams: { questionBankId: this.questionBankId }});
                    } else {
                        this.router.navigate(['./question/' + questionId]);
                    }
                },
                error => {
                    this.errors = (<Result>error).errorList;
                });
        }
    }

    onBack(): void {
        this.location.back();
    }

    addTagFn(name) {
        return { name: name };
    }

    onGetQuestionAnswers($event: QuestionAnswerModel[]): void {
        this.questionAnswers = $event;
    }
}
